import { render, staticRenderFns } from "./PhotoAlbum.vue?vue&type=template&id=4045f854&scoped=true&"
import script from "./PhotoAlbum.vue?vue&type=script&lang=js&"
export * from "./PhotoAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045f854",
  null
  
)

export default component.exports